import ListingsPage from "../../../../components/listing/listing-page"
import {
  fetchDeletedListings,
  fetchListings,
  fetchLocation,
  shouldFetchDeletedAds,
} from "../../../../services/NetworkRequests"
import { REQUEST_SRC_DIRTY } from "../../../../utils/constants"
import { generateAlgoliaQueryFromFilters, dirtyUrlToFilters } from "../../../../utils/filter-utlils"
import {
  checkUA,
  getBreadcrumbs,
  getCappedListingPageRedirect,
  getPaginationUrl,
  parseCookies,
} from "../../../../utils/utility"

const Listings = (props) => {
  const { error } = props
  return error ? <Error statusCode={404} /> : <ListingsPage {...props} />
}

export default Listings

export async function getServerSideProps(ctx) {
  const { query, req, resolvedUrl } = ctx
  const cappedRedirect = getCappedListingPageRedirect(resolvedUrl)
  if (cappedRedirect) {
    return { redirect: { destination: cappedRedirect, permanent: true } }
  }
  const { sort, searchSlug, citySlug, keywords } = query

  let isMobile = checkUA(ctx.req.headers["user-agent"])

  // Parse cookies for feature flag check
  const cookies = parseCookies(req)
  let area = JSON.parse(cookies.area_unit || '{ "short": "Marla", "value": "Marla" }')

  let filters = {}
  let res
  let flipedUrl
  let algoliaQueryObj
  let queryString
  let location
  let breadcrumbs
  let canonical

  try {
    filters = dirtyUrlToFilters(query)
    algoliaQueryObj = generateAlgoliaQueryFromFilters(query, filters)
    queryString = keywords ? keywords.split(",").join(" ") : ""

    // Pass cookies to search functions for backend selection
    let resp = await Promise.all([
      fetchLocation(filters.location_id, cookies),
      fetchListings(sort, algoliaQueryObj, queryString, cookies),
    ])
    location = resp[0]
    res = resp[1]

    flipedUrl = `/search/${citySlug}/${
      filters.purpose_id == 1 ? searchSlug.replace("for-sale", "to-rent") : searchSlug.replace("to-rent", "for-sale")
    }`

    // Both backends return hierarchy in parent→child order (country, province, city, area, location)
    breadcrumbs = await getBreadcrumbs(
      location?.hierarchy?.slice(2).map((item) => item.externalID) || [],
      filters.purpose_id,
      filters.type.id
    )

    canonical = breadcrumbs.slice(-1)[0]?.slug || null
    breadcrumbs = breadcrumbs.slice(0, -1)
    breadcrumbs = breadcrumbs.map((item) => ({ slug: item.slug, title: item.locality_name }))
  } catch (error) {
    return {
      props: {
        error: true,
      },
      notFound: true,
    }
  }

  let deleted = []
  // Only fetch deleted listings for Algolia backend
  if (shouldFetchDeletedAds(cookies) && res.nbHits < 5) {
    let deletedResp = await fetchDeletedListings(algoliaQueryObj, queryString, cookies)
    deleted = deletedResp?.hits.slice(0, 25 - res.nbHits) || []
  }

  const { nextPageLink, prevPageLink } = getPaginationUrl(query, resolvedUrl, res.nbPages)

  return {
    props: {
      isMobile: isMobile,
      hits: res?.hits,
      nbHits: res?.nbHits,
      originalNbHits: res?.originalNbHits || null,
      deletedHits: deleted,
      page: res?.page,
      nbPages: res?.nbPages,
      hitsPerPage: res?.hitsPerPage,
      initialFilters: { ...filters, area },
      flipedUrl: flipedUrl,
      requestSrc: REQUEST_SRC_DIRTY,
      resolvedUrl: ctx.resolvedUrl,
      location: location || null,
      nextPageLink,
      sort: sort || null,
      canonical,
      breadcrumbs,
      prevPageLink,
    },
  }
}
